<template>
  <v-container fluid fill-height class="fail-background" style="max-height: 100vh;">
    <v-layout justify-center align-center column pa-2>
      <div class="white--text text-xs-center mb-3">... PLEASE WAIT ...</div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "fail"
};
</script>
<style scoped>
.fail-background {
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("https://source.unsplash.com/random");
  background-size: cover;
  width: 100%;
  height: 100%;
}
</style>
